export const DEFAULT_COPPERGAT_TERMS = [
  {
    label: 'Quality Assurance:',
    value:
      'Our quality model system is ISO-9001, 14001, OHSAS-18001, CE certified, RoHS compliant and tested from KEMA Holland.',
    highlight: false,
  },
  {
    label: 'Quality Standard:',
    value:
      'COPPERGAT Wires & Cables are being manufactured as per relevant British Standard Specifications (BSS) and International Electrotechnical Commission (IEC) standards.',
    highlight: false,
  },
  {
    label: 'Prices:',
    value:
      'These rates are net and inclusive of GST and are subject to change according to variation in London Metal Exchange (LME), exchange rate of US Dollar or any change in existing policy of Government.',
    highlight: true,
  },
  {
    label: 'Validity:',
    value: '07 days there after subject to our confirmation.',
    highlight: true,
  },
  {
    label: 'Delivery Period:',
    value: '4-5 Weeks or as agreed upon placement of purchase order.',
    highlight: true,
  },
  {
    label: 'Payment:',
    value: '100% Advance.',
    highlight: false,
  },
  {
    label: 'Force Majeure:',
    value:
      'COPPERGAT shall not be held responsible for any delays occuring due to natural causes such as fire, earth-quake, lockout, lockdown, civil chaos and other acts of God.',
    highlight: false,
  },
  {
    label: 'IT & Software:',
    value: 'ERP systems at COPPERGAT Cables are empowered with SAP.',
    highlight: false,
  },
  {
    label: 'Packing:\n(Power Cables)',
    value:
      'Lagged wooden drums on returnable basis. Tolerance (Packing Length) ±5% per individual length or on total quantity. However the actual length will be invoiced.',
    highlight: false,
  },
  {
    label: 'Reliability:',
    value:
      '99.9% pure copper with 100% conductivity and imported cable grade PVC, XLPE, LSZH, PE and other raw materials are being used to manufacture COPPERGAT Cables that yields Full Gauge, Full Current, Full Voltage.',
    highlight: false,
  },
];

export function formatCoppergatEmail(email) {
  if (!email || typeof email !== 'string') return '';
  const trimmed = email.trim();
  if (!trimmed) return '';
  if (/@coppergat\./i.test(trimmed)) {
    return trimmed;
  }
  if (trimmed.includes('@')) {
    const [localPart] = trimmed.split('@');
    if (localPart) {
      return `${localPart}@coppergat.com`;
    }
  }
  return `${trimmed}@coppergat.com`;
}

export function getUserSignature(user) {
  
  if (!user) {
    return {
      name: '',
      title: '',
      company: 'CopperGAT Cables (Pvt) Ltd',
      phone: '',
      email: '',
    };
  }

  const name =
    `${user.firstName || ''} ${user.lastName || ''}`.trim() ||
    user.name ||
    '';

  const rawEmail = user.email || '';

  const result = {
    name,
    title: user.job_description || user.title || user.designation || '',
    company: 'CopperGAT Cables (Pvt) Ltd',
    phone: user.phone || user.phone_number || user.contact || '',
    email: formatCoppergatEmail(rawEmail),
  };
  return result;
}

export function parseTermsConditions(raw) {
  if (!raw) return DEFAULT_COPPERGAT_TERMS;
  if (Array.isArray(raw)) return raw.length ? raw : DEFAULT_COPPERGAT_TERMS;

  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length ? parsed : DEFAULT_COPPERGAT_TERMS;
  } catch {
    return DEFAULT_COPPERGAT_TERMS;
  }
}

export function parseUserSignature(raw, fallbackUser) {
  const fallback = getUserSignature(fallbackUser);
  let parsed = null;

  if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
    parsed = raw;
  } else if (raw) {
    try {
      const p = JSON.parse(raw);
      if (p && typeof p === 'object') {
        parsed = p;
      }
    } catch {
      // fall through to fallback
    }
  }

  if (parsed) {
    const rawEmail = (parsed.email && parsed.email.trim() !== '' && parsed.email !== 'N/A') ? parsed.email : fallback.email;
    const finalSig = {
      name: (parsed.name && parsed.name.trim() !== '' && parsed.name !== 'Unknown') ? parsed.name : fallback.name,
      title: (parsed.title && parsed.title.trim() !== '' && parsed.title !== 'N/A') ? parsed.title : (parsed.job_description && parsed.job_description.trim() !== '' && parsed.job_description !== 'N/A') ? parsed.job_description : fallback.title,
      company: (parsed.company && parsed.company.trim() !== '' && parsed.company !== 'N/A') ? parsed.company : fallback.company || 'CopperGAT Cables (Pvt) Ltd',
      phone: (parsed.phone && parsed.phone.trim() !== '' && parsed.phone !== 'N/A') ? parsed.phone : (parsed.contact && parsed.contact.trim() !== '' && parsed.contact !== 'N/A') ? parsed.contact : fallback.phone,
      email: formatCoppergatEmail(rawEmail),
    };
    // console.log('[DEBUG parseUserSignature] final signature with parsed:', finalSig);
    return finalSig;
  }

  // console.log('[DEBUG parseUserSignature] returning fallback:', fallback);
  return fallback;
}

export function formatQuoteSubjectDate(dateStr) {
  if (!dateStr) return '';

  const parsed = new Date(dateStr);
  if (!Number.isNaN(parsed.getTime())) {
    return parsed.toLocaleDateString('en-GB');
  }

  const parts = dateStr.split('-');
  if (parts.length === 3) {
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }

  return dateStr;
}

export async function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result || '';
      resolve(String(result).split(',')[1] || '');
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
